export const   addCard= 'ADD_PAYMENT_CARD'
export const   removeCard= 'REMOVE_PAYMENT_CARD'
